import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StudentsAchievementsListComponent } from './students-achievements-list/students-achievements-list.component';
import { StudentsAchievementsCreateComponent } from './students-achievements-create/students-achievements-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: StudentsAchievementsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: StudentsAchievementsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'students-achievements-create/:id',
        component: StudentsAchievementsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentsAchievementsRoutingModule { }
